import { EditFilled, UserOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/react-hooks";
import {
  Avatar, Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  message,
  Row, Select, Tooltip,
  Upload
} from "antd";
import ImgCrop from "antd-img-crop";
import React, { useEffect, useState } from "react";
import { fullName } from "../../../Components/Helper/Helper";
import { onFileUpload } from "../../../Components/Helper/MediaUploader";
import { Loader } from "../../../Components/Loader";
import { ShiftTiming } from "../../../Components/ShiftTiming/ShiftTiming";
import { VacationManagement } from "../../../Components/VacationManagement";
import { UPDATE_PROFILE, UPDATE_USER_SHIFTS } from "../../../Graphql/mutations";
import { GET_TIMEZONE, GET_USER_DETAILS } from "../../../Graphql/queries";
import "./Profile.less";

const { REACT_APP_ASSETS_URL } = process.env;
const { Option } = Select;

export const Profile = (props) => {
  const user_id = localStorage.getItem("user_id");
  const [profileImage, setprofileImage] = useState("");
  const [dataLoaded,setDataLoaded] = useState(false)
  const [profileForm] = Form.useForm();
  const [shiftData,setShiftData] = useState({})
  const [timezoneData,setTimeZoneData] = useState([])
  const [timeZoneLoaded,setTimeZoneLoaded] = useState(false)
  const [userShifts, setUserShifts] = useState([]);
  const [locationOptions, setLocationOptions] = useState({});

  const { data: userData, loading } = useQuery(GET_USER_DETAILS, {
    variables: { user_id },
    fetchPolicy: "cache-and-network",
  });
  const { data: timezone } = useQuery(GET_TIMEZONE, {
    variables: { user_id },
    fetchPolicy: "cache-and-network",
  });


  const [UPDATE_PROFILE_MUTATION, { loading: updateProfileLoading }] =
    useMutation(UPDATE_PROFILE);
  const [UPDATE_USER_SHIFTS_MUTATION] =
    useMutation(UPDATE_USER_SHIFTS);
    useEffect(() => {
      if(timezone){
      setTimeZoneData(timezone)
      setTimeZoneLoaded(true)
      }
    },[timezone])
  useEffect(() => {
    if (userData) {
      profileForm.setFieldsValue({
        profile_image: userData.getUsersById.profile_image,
        first_name: userData.getUsersById.first_name,
        last_name: userData.getUsersById.last_name,
        email: userData.getUsersById.email,
        phone: userData.getUsersById.phone,
        employee_code: userData.getUsersById.employee_code,
        role:
          userData.getUsersById.user_location_maps.length > 0
            ? userData.getUsersById.user_location_maps[0]?.jobRoleDetails.role_name
            : null,
        time_zone : userData.getUsersById.time_zone
      });
      let locationList =
      userData.getUsersById.user_location_maps.flatMap(
          ({
            locationDetails: { location_id, location_name, location_timings },
          }) => {
            return [
              {
                location_id,
                location_name,
                workingHours: {
                  openingTime: location_timings.length && location_timings.reduce(
                    (min, curr) =>
                      curr.opening_time < min ? curr.opening_time : min,
                      location_timings[0].opening_time
                  ),
                  closingTime: location_timings.length && location_timings.reduce(
                    (max, curr) =>
                      curr.closing_time > max ? curr.closing_time : max,
                      location_timings[0].closing_time
                  ),
                },
              },
            ];
          }
        );
        setLocationOptions(locationList[0].workingHours);
      setprofileImage(userData.getUsersById.profile_image);
     setUserShifts(userData.getUsersById.user_shifts)
     setDataLoaded(true)
    }
  }, [userData, profileForm]);
  const submitProfileImage = async (value) => {
    value.profile_image = profileImage;
    delete value.role;
    const { data } = await UPDATE_PROFILE_MUTATION({
      variables: {
        user_details: value,
        user_id,
      },
    });
    if (data) {
      message.success("Profile updated successfully");
    }
  };

  const returnUploadedImage = (e) => {
    setprofileImage(e);
  };
  const onFileUploadClick = (e, returnFunc) => {
    onFileUpload(e, "profileImage", returnFunc);
  };
  const onTimeShiftSubmit = async () => {
    
    const { data } = await UPDATE_USER_SHIFTS_MUTATION({
      variables: {
        shifts: shiftData,
        user_id,
      },
    });
    if (data) {
      message.success("Shift timing updated successfully");
    }
  };
  const updateFormValue = (value) => {
    let updatedData  = value.shift_timing.map(data => {
      data.user_id = localStorage.getItem('user_id');
      return data;
    })
    setShiftData(updatedData)
  }
  if (loading) {
    return <Loader />;
  }

  return (
   dataLoaded && timeZoneLoaded ?
     <div>
      <div className="secSubTitle pageSubTilte">
        <div className="stLeft">
          <h5 className="">My profile</h5>
        </div>
      </div>
      <Form
        form={profileForm}
        name="bussiness-edit"
        onFinish={submitProfileImage}
      >
        <div className="profileInContainer">
          <Row gutter={20} className="profileInRow">
            <Col xs={24} sm={24} xl={24} className="w-100 d-flex justify-content-center">
              <Tooltip
                trigger={["focus"]}
                title="Profile Image"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="profile_image" className="">
                  <div style={{ position: "relative" }}>
                    {!profileImage ? (
                      <Avatar
                      //  icon={<UserOutlined />}
                        size={100}
                        className="userAvatar"
                      >
                        {fullName(profileForm.getFieldValue("first_name") +
                          profileForm.getFieldValue("last_name"))}
                      </Avatar>
                    ) : (
                      <Avatar
                        src={REACT_APP_ASSETS_URL + profileImage}
                        icon={<UserOutlined />}
                        size={100}
                        className="userAvatar"
                      ></Avatar>
                    )}
                    <ImgCrop
                      zoom={false}
                      modalOk={"Crop"}
                      modalTitle={"Crop Image"}
                    >
                      <Upload
                        showUploadList={false}
                        customRequest={(e) =>
                          onFileUploadClick(e, returnUploadedImage)
                        }
                      >
                        <Button
                          type="primary"
                          className="editButton"
                          icon={<EditFilled />}
                        ></Button>
                      </Upload>
                    </ImgCrop>
                  </div>
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="First Name"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      message: "First Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid First name",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="Last Name"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: "Last Name is required",
                      whitespace: true,
                    },
                    {
                      pattern: new RegExp(
                        "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$"
                      ),
                      message: "Invalid Last name",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Tooltip>
            </Col>
            
            <Col xs={24} sm={12} xl={12}>
            <Tooltip
              trigger={["focus"]}
              title="Time Zone"
              placement="topLeft"
              overlayClassName="numeric-input"
            >
              <Form.Item
                name="time_zone"
                rules={[
                  {
                    required: true,
                    message: "time zone is required",
                    whitespace: true,
                  },
                ]}
              >
                <Select>
                {timezoneData.getLocations.map((data,index) => {
                 return  <Option key={index} value={data.timezone_id}>{data.timezone_name}</Option>
                })}
                </Select>
              </Form.Item>
            </Tooltip>
          </Col> 
          {props.userData.getUsersById.user_access.access_id !== '1' && 
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="Employee Code"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="employee_code"
                  rules={[
                    {
                      required: true,
                      message: "Employee Code is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Tooltip>
            </Col>}
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="Phone No"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="phone">
                  <Input disabled />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="Email"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email Address is required",
                      whitespace: true,
                    },
                    {
                      type: "email",
                      message: "Enter Valid Email Address",
                    },
                  ]}
                >
                  <Input disabled/>
                </Form.Item>
              </Tooltip>
            </Col>
            
            <Col xs={24} sm={12} xl={12}>
              <Tooltip
                trigger={["focus"]}
                title="Role"
                placement="topLeft"
                overlayClassName="numeric-input"
              >
                <Form.Item name="role">
                  <Input disabled />
                </Form.Item>
              </Tooltip>
            </Col>
            <Col xs={24} sm={24} xl={24}>
              <Form.Item className="text-center">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  success
                  htmlType="submit"
                  loading={updateProfileLoading}
                >
                  Update
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
      <Divider />
      <Row>
        <Col xs={24} sm={24} xl={24}>
          <div className="emplyshiftTiming">
            <div className="secSubTitle pageSubTilte">
              <div className="stLeft">
                <h5>Edit Shift Schedule</h5>
              </div>
              <div className="stright d-flex align-items-center"></div>
            </div>
            <Card>
              <ShiftTiming locationHours={locationOptions} userType={props.userData.getUsersById.user_access.access_id} initialValue={userShifts} updateFormValue={(value) => updateFormValue(value)}/>
              <div className="text-center pt-2">
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  success
                  //htmlType="submit"
                  onClick={() => onTimeShiftSubmit()}>
                
                  Update
                </Button>
              </div>
            </Card>
          </div>
        </Col>
      </Row>

      <Divider />
      <VacationManagement />
    </div>
    : <Loader/>
  );
};
